'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends13 = require('babel-runtime/helpers/extends');

var _extends14 = _interopRequireDefault(_extends13);

exports.makeReducer = makeReducer;

var _es = require('@zaibot/fsa/es5');

var _utils = require('../utils');

var _fields = require('./fields');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

let requireId = item => {
    if (!item) {
        throw new Error('Expecting item.');
    }
    let id = item[_fields.fields.id];

    if (!id) {
        throw new Error('Expecting id to be filled, use resource.create({ ... }) to create a new instance.');
    }
    return id;
};
let requireTempId = item => {
    if (!item) {
        throw new Error('Expecting item.');
    }
    let tempId = item[_fields.fields.tempId];

    if (!tempId) {
        throw new Error('Expecting tempId to be filled, use resource.create({ ... }) to create a new instance.');
    }
    return tempId;
};
function makeReducer(descriptor) {
    let emptyState = {
        error: null,
        list: [],
        loading: false,
        params: null
    };
    let actions = descriptor.actions;

    return function () {
        let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;
        let action = arguments[1];

        if ((0, _es.isType)(action, actions.CREATE)) {
            requireTempId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listAddOrUpdate)(descriptor, state.list, action.payload.item, item => {
                    var _extends2;

                    return (0, _extends14.default)({}, item, action.payload.item, (_extends2 = {}, (0, _defineProperty3.default)(_extends2, _fields.fields.error, null), (0, _defineProperty3.default)(_extends2, _fields.fields.isModified, { time: Date.now() }), (0, _defineProperty3.default)(_extends2, _fields.fields.isCreating, { time: Date.now() }), _extends2));
                })
            });
        } else if ((0, _es.isType)(action, actions.CREATE_SUCCESS)) {
            requireTempId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listAddOrUpdate)(descriptor, state.list, action.payload.item, item => {
                    var _extends3;

                    return (0, _extends14.default)({}, item, action.payload.item, (_extends3 = {}, (0, _defineProperty3.default)(_extends3, _fields.fields.error, null), (0, _defineProperty3.default)(_extends3, _fields.fields.isModified, false), (0, _defineProperty3.default)(_extends3, _fields.fields.isCreating, false), (0, _defineProperty3.default)(_extends3, _fields.fields.isCreated, { time: Date.now() }), _extends3));
                })
            });
        } else if ((0, _es.isType)(action, actions.CREATE_FAILURE)) {
            requireTempId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listAddOrUpdate)(descriptor, state.list, action.payload.item, item => {
                    var _extends4;

                    return (0, _extends14.default)({}, item, action.payload.item, (_extends4 = {}, (0, _defineProperty3.default)(_extends4, _fields.fields.error, action.payload.reason), (0, _defineProperty3.default)(_extends4, _fields.fields.isCreating, false), _extends4));
                })
            });
        } else if ((0, _es.isType)(action, actions.READ)) {
            requireId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listAddOrUpdate)(descriptor, state.list, action.payload.item, item => {
                    var _extends5;

                    return (0, _extends14.default)({}, item, action.payload.item, (_extends5 = {}, (0, _defineProperty3.default)(_extends5, _fields.fields.error, null), (0, _defineProperty3.default)(_extends5, _fields.fields.isReading, false), _extends5));
                })
            });
        } else if ((0, _es.isType)(action, actions.UPDATE)) {
            requireId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listAddOrUpdate)(descriptor, state.list, action.payload.item, item => {
                    var _extends6;

                    return (0, _extends14.default)({}, item, action.payload.item, (_extends6 = {}, (0, _defineProperty3.default)(_extends6, _fields.fields.error, null), (0, _defineProperty3.default)(_extends6, _fields.fields.isModified, { time: Date.now() }), (0, _defineProperty3.default)(_extends6, _fields.fields.isUpdating, { time: Date.now() }), _extends6));
                })
            });
        } else if ((0, _es.isType)(action, actions.UPDATE_CANCEL)) {
            requireId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listAddOrUpdate)(descriptor, state.list, action.payload.item, item => {
                    var _ref;

                    return _ref = {}, (0, _defineProperty3.default)(_ref, _fields.fields.error, null), (0, _defineProperty3.default)(_ref, _fields.fields.isUpdating, false), _ref;
                })
            });
        } else if ((0, _es.isType)(action, actions.UPDATE_SUCCESS)) {
            requireId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listAddOrUpdate)(descriptor, state.list, action.payload.item, item => {
                    var _extends7;

                    return (0, _extends14.default)({}, item, action.payload.item, (_extends7 = {}, (0, _defineProperty3.default)(_extends7, _fields.fields.error, null), (0, _defineProperty3.default)(_extends7, _fields.fields.isModified, false), (0, _defineProperty3.default)(_extends7, _fields.fields.isUpdating, false), (0, _defineProperty3.default)(_extends7, _fields.fields.isUpdated, { time: Date.now() }), _extends7));
                })
            });
        } else if ((0, _es.isType)(action, actions.UPDATE_FAILURE)) {
            requireId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listAddOrUpdate)(descriptor, state.list, action.payload.item, item => {
                    var _extends8;

                    return (0, _extends14.default)({}, item, (_extends8 = {}, (0, _defineProperty3.default)(_extends8, _fields.fields.error, action.payload.reason), (0, _defineProperty3.default)(_extends8, _fields.fields.isUpdating, false), _extends8));
                })
            });
        } else if ((0, _es.isType)(action, actions.DELETE)) {
            requireId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listAddOrUpdate)(descriptor, state.list, action.payload.item, item => {
                    var _extends9;

                    return (0, _extends14.default)({}, item, (_extends9 = {}, (0, _defineProperty3.default)(_extends9, _fields.fields.error, null), (0, _defineProperty3.default)(_extends9, _fields.fields.isModified, { time: Date.now() }), (0, _defineProperty3.default)(_extends9, _fields.fields.isRemoving, { time: Date.now() }), _extends9));
                })
            });
        } else if ((0, _es.isType)(action, actions.DELETE_CANCEL)) {
            requireId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listAddOrUpdate)(descriptor, state.list, action.payload.item, item => {
                    var _extends10;

                    return (0, _extends14.default)({}, item, (_extends10 = {}, (0, _defineProperty3.default)(_extends10, _fields.fields.error, null), (0, _defineProperty3.default)(_extends10, _fields.fields.isRemoving, false), _extends10));
                })
            });
        } else if ((0, _es.isType)(action, actions.DELETE_SUCCESS)) {
            requireId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listRemove)(descriptor, state.list, action.payload.item)
            });
        } else if ((0, _es.isType)(action, actions.DELETE_FAILURE)) {
            requireId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listAddOrUpdate)(descriptor, state.list, action.payload.item, item => {
                    var _extends11;

                    return (0, _extends14.default)({}, item, (_extends11 = {}, (0, _defineProperty3.default)(_extends11, _fields.fields.error, action.payload.reason), (0, _defineProperty3.default)(_extends11, _fields.fields.isRemoving, false), _extends11));
                })
            });
        } else if ((0, _es.isType)(action, actions.LIST)) {
            return (0, _extends14.default)({}, state, { loading: { time: Date.now() } });
        } else if ((0, _es.isType)(action, actions.LIST_CANCEL)) {
            return (0, _extends14.default)({}, state, { loading: false, error: null });
        } else if ((0, _es.isType)(action, actions.LIST_SUCCESS)) {
            return (0, _extends14.default)({}, state, {
                error: null,
                list: action.payload.list.map(item => {
                    return (0, _extends14.default)({}, item, (0, _defineProperty3.default)({}, _fields.fields.isRead, true));
                }),
                loading: false,
                params: action.payload.params
            });
        } else if ((0, _es.isType)(action, actions.LIST_FAILURE)) {
            return (0, _extends14.default)({}, state, { loading: false, error: Error(action.payload.reason) });
        } else if ((0, _es.isType)(action, actions.RESET)) {
            return (0, _extends14.default)({}, state, { loading: false, error: null, list: [], params: {} });
        }
        return state;
    };
}
//# sourceMappingURL=makeReducer.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/resource/makeReducer.js